import { render, staticRenderFns } from "./Covid19Tracker.vue?vue&type=template&id=018315a1&scoped=true&"
import script from "./Covid19Tracker.js?vue&type=script&lang=js&"
export * from "./Covid19Tracker.js?vue&type=script&lang=js&"
import style0 from "./Covid19Tracker.scss?vue&type=style&index=0&id=018315a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018315a1",
  null
  
)

export default component.exports